<template>
    <div :class="['page', language === 'cn' ? 'font-cn' : 'font-en']">
      <!-- Content Section and Navigation Together -->
      <div class="content-wrapper">
        <!-- Content Section -->
        <div class="content-section">
          <div v-for="(item, index) in content.Items" :key="index" class="content-item">
            <div class="card">  
              <div class="card-body">
                <h1 class="title">{{ item.title }}</h1>
                <div v-html="formattedDescription(item.description_1)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_1" alt="Content Image" class="image" />
                </div>  
                <div v-html="formattedDescription(item.description_2)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_2" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_3)" class="description"></div>
                <div class="card-header">
                  <img :src="item.image_3" alt="Content Image" class="image" />
                </div>
                <div v-html="formattedDescription(item.description_4)" class="description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <style src="@/assets/css/news.css" scoped></style>
  
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        cn: {
          Items: [
            {
              id: 1,
              image_1: require("@/assets/img/News/009/SigningCeremony.jpg"),
              image_3: require("@/assets/img/News/009/Jabin114514.jpg"),
              image_2: require("@/assets/img/News/009/ImmersiveParkProject.jpg"),
              title: "云翰虹章出席诺丁汉大学全球创新创业生态大会，深化国际交流合作",
              description_1:`
                2024年9月28日，云翰虹章团队荣幸参与了由诺丁汉大学与侨联联合举办的Global Pitch活动。在会议期间，云翰虹章团队与来自匈牙利的VR Vidámpark团队正式签署战略合作协议。
              `,
              description_2:`
              自2024年4月12日来，云翰虹章团队与VR Vidámpark团队结缘，协助其在中国发展，并致力于解决中外合作中出现的各种问题。在Global Pitch这一个荣重的场合，双方在侨联和诺丁汉大学的共同见证下达成合作共识。

              `,
              description_3:`
              此外，贾斌作为沉浸视界项目(Immersive Park Project)的负责人对项目的设计构想进行了详细汇报与展示，并获得了与会者的高度认可。

              `,
              description_4:`
              云翰虹章团队在会议期间与VR Vidámpark团队就未来合作项目进行了深入探讨，双方将在未来的合作中共同推动中国文化旅游产业的发展，为更多游客带来独特的沉浸式体验。

              `,
            },
            // Add more items as needed
          ],
        },
        en: {
          Items: [
            {
              id: 2,
              image_1: require("@/assets/img/News/009/SigningCeremony.jpg"),
              image_3: require("@/assets/img/News/009/Jabin114514.jpg"),
              image_2: require("@/assets/img/News/009/ImmersiveParkProject.jpg"),
              title: "Rosy Nebula attends University of Nottingham's Global Pitch",
              description_1:`
              On 28th September 2024, the Rosy Nebula Delegation was honoured to participate in the Global Pitch event organised by the University of Nottingham and the Overseas Chinese Association. During the conference, Rosy Nebula signed a strategic cooperation agreement with VR Vidámpark from Hungary.
              `,
              description_2:`
              Since 12 April 2024, the Rosy Nebula team has been collaborating with the VR Vidámpark team, assisting them in their development in China and working to resolve issues that arise in both Chinese and foreign collaborations. On the occasion of Global Pitch, the two parties reached a consensus on cooperation in the presence of the Overseas Chinese Association and the University of Nottingham.

              `,
              description_3:`
              In addition, Jia Bin, as the manager of the Immersive Park Project, made a detailed report and demonstration of the project's design concept, which was highly recognised by the participants.

              `,
              description_4:`
              The Rosy Nebula team had an in-depth discussion with the VR Vidámpark team on future cooperation projects during the conference, and both parties will work together to promote the development of China's cultural tourism industry, and bring unique immersive experiences to more tourists in the future.
              
              `,
            },
            // Add more items as needed
          ],
        },
      };
    },
    methods: {
      formattedDescription(description) {
        // Apply additional formatting if needed
        return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
      formattedDescriptionNo(description_no) {
        // Apply additional formatting if needed
        return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
      },
    },
    mixins: [],
    computed: {
      ...mapState(["language"]),
      content() {
        const defaultContent = { title: "", industry_areas: [] };
        const currentLanguage = this.language === "en" ? this.en : this.cn;
        console.log("Current Language:", currentLanguage); // Debug statement
        return currentLanguage || defaultContent;
      },
    },
    watch: {
      language(newValue) {
        console.log("Language changed to:", newValue); // Debug statement
        this.$forceUpdate(); // Force the component to re-render when the language changes
      },
    },
  };
  </script>
